var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('program-template-index',{attrs:{"formSearch":_vm.formSearch,"enableExport":false,"hide-action":false,"columns":_vm.columns,"title":_vm.$t('menu.program_template_list'),"serviceName":_vm.serviceName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }